<template>
    <b-col>
        <b-row>
            <h3 class="ml-3">Mass-Action-Interface</h3>
        </b-row>
        <b-row v-if="job.success === true">
            <b-alert variant="success" :show="job.success" dismissable>Job erfolgreich durchgelaufen</b-alert>
        </b-row>
        <b-row v-else-if="job.success === false">
            <b-alert variant="danger" :show="job.success">Job Fehler</b-alert>
        </b-row>
        <b-row class="my-2">
            <b-row class="pl-2">
                <b-dropdown id="dropdown-1" dropright :v-model="job.type" :text="job.type" class="m-md-2">
                    <!--b-dropdown-item @click="job.type = 'Spoof'">Spoof</b-dropdown-item -->
                    <b-dropdown-item @click="job.type = 'Freigeben WNK'">Freigeben WNK</b-dropdown-item>
                    <b-dropdown-item @click="job.type = 'Kommentar'">Kommentar</b-dropdown-item>
                </b-dropdown>
                <b-col class="pt-2">
                    <b-button
                        block
                        size="md"
                        @click="submit()"
                        :disabled="job.processing"
                        variant="primary"
                    >
                        <b-spinner v-if="job.processing" small  label="Spinning"/>
                        <span>Ausführen</span>
                    </b-button>
                </b-col>
            </b-row>
            <b-form-textarea
                v-if="job.type === 'Kommentar'"
                id="textareaComment"
                v-model="comment"
                placeholder="Hier Kommentar eingeben"
                rows="3"
                max-rows="5"
            ></b-form-textarea>
            <b-form-textarea
                id="textarea"
                v-model="job.payloadRaw"
                placeholder="..."
                rows="12"
                max-rows="50"
            ></b-form-textarea>
        </b-row>
        <b-modal v-model="job.processing" size="md" centered>{{job.modalMessage}}</b-modal>
        <b-modal v-model="modalError.state" size="md" centered dismissible>{{modalError.message}}</b-modal>
    </b-col>

</template>
<script>
  export default
  {
    props: [],
    data() {
        return {
            job: {
                type: 'Freigeben WNK',
                payloadRaw: '', // needs to be serialized
                payloadSerialized: [],
                url: '',
                //position: -1, // current position in job queue. If necessary we can add a "erneut versuchen" button and functionality.
                count: -1, //sub-job count
                modalMessage: '',
                processing: false,
                success: null
            },
            comment: '',
            modalError: {
                state: false,
                message: ""
            }
        }
    },
    methods: {
        resetJob() {
            this.job = {
                type: 'Freigeben WNK',
                payloadRaw: '',
                payloadSerialized: [],
                url: '',
                count: -1,
                modalMessage: '',
                processing: false,
                success: this.job.success
            };
        },
        prepareJob() {
         // prepare job
            switch(this.job.type) {
                case 'Freigeben WNK': this.job.url = '/customerorder/unfreezewnc'; break;
                case 'Kommentar': this.job.url = '/customerorderhistory'; break;
            }

            this.job.payloadSerialized = this.job.payloadRaw.split('\n');
            this.job.payloadSerialized = this.job.payloadSerialized
                                            .map( x => x.replace(/\s+/g, ''))
                                            .filter( x => x.length > 0 ); // remove empty rows and whitespace
            this.job.count = this.job.payloadSerialized.length;
        },
        submit() {
            this.prepareJob();
            this.job.processing = true;
            this.job.success = null;
            this.makeRequest(this.job.payloadSerialized).then( () => {
                //console.log"jobs finished");
                this.job.processing = false;
                this.job.success = true;
                this.resetJob();
            }).catch( error => {
                this.job.success = false;
                this.job.processing = false;
                console.error(error);
                this.modalError = {
                    state: true,
                    message: "Netzwerkfehler. Error: " + JSON.stringify(error.response.data.message)
                }
            });
        },
        makeRequest(ids) {
            return new Promise( (resolve, reject) => {
                //console.logtypeof ids);
                //console.logids);

            switch(this.job.type) {
                case 'Freigeben WNK': 
                
                    let payload = { id: ids.pop(), type: this.job.type };

                    axios.post(`${this.job.url}/${payload.id}`, payload ).then( response => {
                        let percent = 100 * (1 - (ids.length / this.job.count));
                        this.job.modalMessage = `Bitte warten: verarbeite ${this.job.type} Position ${this.job.count - ids.length} von ${this.job.count} (${percent.toFixed(2)}%).`;
                        //console.log(`response.body: ${response.data}`);
                        resolve((ids.length <= 0) ? null : this.makeRequest(ids));
                    }).catch( error => {
                        this.job.processing = false;
                        console.error(error);
                        this.modalError = {
                            state: true,
                            message: "Netzwerkfehler. Error: " + JSON.stringify(error.response.data.message)
                        }
                        reject(error);
                    });
                
                break;

                case 'Kommentar': 
                    let commentPayload = 
                    { 
                        customerOrderId: ids.pop(),
                        comment : this.comment,
                        lastUpdateReason : 'Mass-Action-Interface'
                    };

                    axios.post(`${this.job.url}`, commentPayload ).then( response => {
                        let percent = 100 * (1 - (ids.length / this.job.count));
                        this.job.modalMessage = `Bitte warten: verarbeite ${this.job.type} Position ${this.job.count - ids.length} von ${this.job.count} (${percent.toFixed(2)}%).`;
                        //console.log(`response.body: ${response.data}`);
                        resolve((ids.length <= 0) ? null : this.makeRequest(ids));
                    }).catch( error => {
                        this.job.processing = false;
                        console.error(error);
                        this.modalError = {
                            state: true,
                            message: "Netzwerkfehler. Error: " + JSON.stringify(error.response.data.message)
                        }
                        reject(error);
                    });                
                
                break;
            }

            });
        },       
    }
  }
</script>
